import { gql } from 'graphql-request';

export const FRAGMENT_MSA_PREVIEW = gql`
  fragment MsaPreview on MsaDetails {
    msa
    name
    zipCount
  }
`;
